import { FormConnectStepsType } from '../../../abstract/provider.client'
import { StepOne } from './steps/StepOne'

export const FormConnectSteps: FormConnectStepsType = ({
  stepIndex,
  account,
  provider,
  onNext,
  onSubmit,
}) => {
  return (
    <>
      {stepIndex === 1 && (
        <StepOne account={account} provider={provider} onSubmit={onSubmit} />
      )}
    </>
  )
}
